import type { Effect, Reducer } from 'umi';

import type { WarehouseBillDataType } from './data';
import { getWarehouseBillDetail } from './service';

export interface StateType {
  warehouseBill?: WarehouseBillDataType;
}

export interface ModelType {
  namespace: string;
  state: StateType;
  effects: {
    get: Effect;
  };
  reducers: {
    save: Reducer<StateType>;
    clear: Reducer<StateType>;
  };
}

const Model: ModelType = {
  namespace: 'wmsBillModel',
  state: {
    warehouseBill: undefined,
  },
  effects: {
    *get({ payload }, { call, put }) {
      const response = yield call(getWarehouseBillDetail, payload);
      yield put({
        type: 'save',
        payload: response.data,
      });
    },
  },

  reducers: {
    save(state, action) {
      return {
        ...state,
        warehouseBill: action.payload,
      };
    },
    clear() {
      return {
        warehouseBill: undefined,
      };
    },
  },
};

export default Model;
